module.exports = __webpack_public_path__ + "media/homepage/fastweb-homepage-bg-386fd722.jpg";